<template>
  <v-container id="reservation-reception-search-location-component">
    <c-card title="출발지 / 도착지 설정" class="mt-12">
      <v-row>
        <v-col cols="12" lg="4" class="pr-10 pl-5">
          <v-row class="mb-3">
            <v-radio-group dense row v-model="input.radioTownLocationInfo">
              <v-radio
                  v-for="location in townLocationInfo"
                  :key="location.value"
                  :label="location.label"
                  :value="location.value">
              </v-radio>
            </v-radio-group>
            <v-menu
              v-if="suburbanFareType === 'suburban_fr_area'"
              transition="scale-transition"
              nudge-bottom="30"
              allow-overflow
              max-width="500px"
              max-height="300px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  append-icon="keyboard_arrow_down"
                  :value="getAreaText(input.suburban.selectedSuburban)"
                  dense readonly
                  :disabled = isEnableSuburban()
                  style="margin-top: 15px"
                />
              </template>
              <v-list>
                <v-list-item
                    v-for="(item, index) in sortedSuburbanAreaFareTypes"
                    :key="index"
                    @click="input.suburban.selectedSuburban = item">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.area }}구간</v-list-item-title>
                    <v-list-item-subtitle>{{ item.areaDescription }}({{ item.fare }}원)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>

          <v-row>
            <v-col col="12" class="d-flex reverse pa-0">
              <v-menu
                v-model="input.startPoint.showPositionList"
                transition="scale-transition"
                nudge-bottom="30"
                allow-overflow
                max-width="500px"
                max-height="300px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="출발지"
                    v-model="input.startPoint.positionText"
                    @click="getHomeAddress; getRecentAddressList; showRecentList(input.startPoint, $event)"
                    @input="showRecentList(input.startPoint, $event);"
                    @keydown.enter="onSetPosition(input.startPoint, false);"
                    clearable
                    dense
                    ref="startPoint"
                  />
                </template>

                <v-list>
                  <v-list-item
                    v-for="(position, index) in input.homeAddress.positionList"
                    :key="index"
                    :hidden ="hiddenHomeAndRecentList(input.startPoint)"
                    dense
                    @click="onSelectedPosition(position, input.startPoint)">
                    <v-list-item-icon>
                      <v-icon v-if="index === 0" color="yellow"> mdi-star </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.comment ? position.comment : '' }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider :hidden ="hiddenHomeAndRecentList(input.startPoint)"></v-divider>
                  <v-subheader :hidden ="hiddenHomeAndRecentList(input.startPoint)">최근 이용 내역</v-subheader>

                  <v-list-item
                      v-for="(position, index) in input.recentPositions"
                      :key="index"
                      :hidden ="hiddenHomeAndRecentList(input.startPoint)"
                      dense
                      @click="onSelectedPosition(position, input.startPoint)">
                    <v-list-item-content>
                      <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                      v-for="(position, index) in input.startPoint.positionList"
                      :key="index"
                      :hidden ="hiddenHomeAndRecentList(input.startPoint) == false"
                      dense
                      @click="onSelectedPosition(position, input.startPoint)">
                    <v-list-item-content>
                      <v-list-item-title>{{ position.place_name }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.address_name }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="12" v-if="input.startPoint.addressText" class="mt-0 pt-0">
              <v-row>
                <v-col cols="11" class="my-0 py-0">
                  <v-icon>done</v-icon>
                  <span class="font-weight-bold"> {{ this.input.startPoint.addressText }}</span>
                </v-col>
                <v-col cols="1" class="my-0 px-0 py-0">
                  <v-icon v-if="input.startPoint.addressText"
                          @click="getHomeAddress; getRecentAddressList; startPointClear(input.startPoint, $event);"
                  >close</v-icon>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0 ml-3">
              <v-textarea
                rows="1"
                prepend-inner-icon="mode_comment"
                label="출발지 추가정보"
                dense clearable outlined
                auto-grow hide-details
                v-model="input.comments[0]">
              </v-textarea>
            </v-col>
          </v-row>

          <v-row style="margin-top: 20px">
            <v-menu
                v-model="input.endPoint.showPositionList"
                transition="scale-transition"
                nudge-bottom="30"
                allow-overflow
                max-width="500px"
                max-height="300px">
              <template v-slot:activator="{ on }">
                <v-text-field
                    label="도착지"
                    v-model="input.endPoint.positionText"
                    @click="getHomeAddress; getRecentAddressList; showRecentList(input.endPoint, $event)"
                    @input="showRecentList(input.endPoint, $event)"
                    @keydown.enter="onSetPosition(input.endPoint, false)"
                    clearable
                    dense
                    ref="endPoint"
                >
                </v-text-field>
              </template>
              <v-list>
                <v-list-item
                    v-for="(position, index) in input.homeAddress.positionList"
                    :key="index"
                    :hidden ="hiddenHomeAndRecentList(input.endPoint)"
                    dense
                    @click="onSelectedPosition(position, input.endPoint)">
                  <v-list-item-icon>
                    <v-icon v-if="index === 0" color="yellow"> mdi-star </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                    <v-list-item-subtitle>{{ position.comment ? position.comment : '' }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider :hidden ="hiddenHomeAndRecentList(input.endPoint)"></v-divider>
                <v-subheader :hidden ="hiddenHomeAndRecentList(input.endPoint)">최근 이용 내역</v-subheader>

                <v-list-item
                    v-for="(position, index) in input.recentPositions"
                    :key="index"
                    :hidden ="hiddenHomeAndRecentList(input.endPoint)"
                    dense
                    @click="onSelectedPosition(position, input.endPoint)">
                  <v-list-item-content>
                    <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                    <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-for="(position, index) in input.endPoint.positionList"
                    :key="index"
                    :hidden ="hiddenHomeAndRecentList(input.endPoint) == false"
                    dense
                    @click="onSelectedPosition(position, input.endPoint)">
                  <v-list-item-content>
                    <v-list-item-title>{{ position.place_name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ position.address_name }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-menu>
            <v-col cols="12" v-if="input.endPoint.addressText" class="mt-0 pt-0">
              <v-row>
                <v-col cols="11" class="my-0 py-0">
                  <v-icon>done</v-icon>
                  <span class="font-weight-bold"> {{ this.input.endPoint.addressText }}</span>
                </v-col>
                <v-col cols="1" class="my-0 px-0 py-0">
                  <v-icon v-if="input.endPoint.addressText"
                          @click="getHomeAddress; getRecentAddressList; endPointClear(input.endPoint, $event);"
                  >close</v-icon>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0 ml-3">
              <v-textarea
                rows="1"
                prepend-inner-icon="mode_comment"
                label="도착지 추가정보"
                dense clearable outlined
                auto-grow hide-details
                v-model="input.comments[1]"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row v-for="(waypoint, index) in input.waypoints" :key="index" style="margin-top: 20px">
            <v-col class="d-flex reverse pa-0">
              <v-menu
                v-model="waypoint.showPositionList"
                transition="scale-transition"
                nudge-bottom="30"
                allow-overflow
                max-width="500px"
                max-height="300px">

                <template v-slot:activator="{ on }">
                  <v-text-field
                    :label="'경유지'+(index+1)" clearable
                    v-model="waypoint.positionText"
                    @click="getHomeAddress; getRecentAddressList; showRecentList(waypoint, $event)"
                    @input="showRecentList(waypoint, $event)"
                    @keydown.enter="onSetPosition(waypoint, false)"
                    dense
                    :disabled="input.wayPointStatus"
                    ref="wayPoint"
                  ></v-text-field>
                </template>

                <v-list>
                  <v-list-item
                      v-for="(position, index) in input.homeAddress.positionList"
                      :key="index"
                      :hidden ="hiddenHomeAndRecentList(waypoint)"
                      dense
                      @keyup.enter="onSelectedPosition(position, waypoint)"
                      @click="onSelectedPosition(position, waypoint)">
                    <v-list-item-icon>
                      <v-icon v-if="index == 0" color="yellow"> mdi-star </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.comment ? position.comment : '' }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider :hidden ="hiddenHomeAndRecentList(waypoint)"></v-divider>
                  <v-subheader :hidden ="hiddenHomeAndRecentList(waypoint)">최근 이용 내역</v-subheader>

                  <v-list-item
                      v-for="(position, index) in input.recentPositions"
                      :key="index"
                      :hidden ="hiddenHomeAndRecentList(waypoint)"
                      dense
                      @click="onSelectedPosition(position, waypoint)">
                    <v-list-item-content>
                      <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                      v-for="(position, index) in waypoint.positionList"
                      :key="index"
                      :hidden ="hiddenHomeAndRecentList(waypoint) == false"
                      dense
                      @click="onSelectedPosition(position, waypoint)">
                    <v-list-item-content>
                      <v-list-item-title>{{ position.place_name }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.address_name }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="12" v-if="waypoint.addressText" class="mt-0 pt-0">
              <v-row>
                <v-col cols="11" class="my-0 py-0">
                  <v-icon>done</v-icon>
                  <span class="font-weight-bold"> {{ waypoint.addressText }}</span>
                </v-col>
                <v-col cols="1" class="my-0 px-0 py-0">
                  <v-icon v-if="waypoint.addressText"
                          @click="getHomeAddress; getRecentAddressList; waypointClear(waypoint, $event, index);"
                  >close</v-icon>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0 ml-3">
              <v-textarea
                rows="1"
                prepend-inner-icon="mode_comment"
                :label="'경유지'+(index+1)+' 추가정보'"
                dense clearable outlined
                auto-grow hide-details
                v-model="input.comments[index+2]"
                :disabled="input.wayPointStatus"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row justify="center">
            <c-btn :disabled="input.disableWayPointAddBtn" color="blue" icon iconName="add" @click="onCalcWayPoints('+')"/>
            <c-btn :disabled="input.disableWayPointRemoveBtn" color="blue" icon iconName="remove" @click="onCalcWayPoints('-')"/>
          </v-row>
        </v-col>

        <v-col cols="12" lg="8">
          <v-row justify="end">
            <div v-if="this.input.locationInfo && this.input.locationInfo.driveTime" class="info-container">
              <span class="white--text subtitle-2"> 예상 주행 시간 : {{getDriveTime}}</span>
              <br/>
              <span class="white--text subtitle-2"> 예상 주행 거리 : {{getDriveDistance}} km</span>
              <br/>
              <span class="white--text subtitle-2"> 예상 주행 요금 : {{this.input.locationInfo._2UFare}} 원</span>
              <br/>
              <span class="white--text subtitle-2"> 예상 도움서비스 요금 : {{this.input.locationInfo._2UServiceFare}} 원</span>
            </div>
            <naver-maps
              :width="map.width"
              :height="map.height"
              :mapOptions="map.mapOptions"
              :initLayers="map.initLayers"
              @load="onMapLoad">


              <naver-marker v-if="input.startPoint.selectedPosition"
                            :lat="parseFloat(input.startPoint.selectedPosition.y)"
                            :lng="parseFloat(input.startPoint.selectedPosition.x)"
                            @click="onMapMarkerClicked" @load="onMapMarkerLoaded"/>

              <naver-marker v-if="input.endPoint.selectedPosition"
                            :lat="parseFloat(input.endPoint.selectedPosition.y)"
                            :lng="parseFloat(input.endPoint.selectedPosition.x)"
                            @click="onMapMarkerClicked" @load="onMapMarkerLoaded"/>

              <naver-marker v-if="input.waypoints[0] && input.waypoints[0].selectedPosition"
                            :lat="parseFloat(input.waypoints[0].selectedPosition.y)"
                            :lng="parseFloat(input.waypoints[0].selectedPosition.x)"
                            @click="onMapMarkerClicked" @load="onMapMarkerLoaded"/>

              <naver-marker v-if="input.waypoints[1] && input.waypoints[1].selectedPosition"
                            :lat="parseFloat(input.waypoints[1].selectedPosition.y)"
                            :lng="parseFloat(input.waypoints[1].selectedPosition.x)"
                            @click="onMapMarkerClicked" @load="onMapMarkerLoaded"/>

              <naver-marker v-if="input.waypoints[2] && input.waypoints[2].selectedPosition"
                            :lat="parseFloat(input.waypoints[2].selectedPosition.y)"
                            :lng="parseFloat(input.waypoints[2].selectedPosition.x)"
                            @click="onMapMarkerClicked" @load="onMapMarkerLoaded"/>

              <naver-polyline v-if="this.input.path"
                              :path="this.input.path"
                              @load="onMapPolylineLoaded"/>
            </naver-maps>
          </v-row>

        </v-col>
      </v-row>
    </c-card>
  </v-container>
</template>
<script>
  export default {
    props: {
      reservationData : {
        type: Object
      },
      locationData: {
        type: Object
      },
      commentsData: {
        type: Object
      },
      customerData : {
        type: Array
      },
      fareInfo : {
        type: Object
      }
    },
    data: () => ({
      // 해당 센터에 설정된 시내, 시외, 시외구간요금 정보들
      fareType: '',
      suburbanFareType: '',
      suburbanAreaFareTypes: [],

      // 선택한 요금 타입 및 요금 디테일 정보
      selectedFareType: '',
      selectedFareDetail: '',

      endMarker: null,
      open: false,

      input : {
        radioTownLocationInfo : "downTown",
        selectSection : "",
        suburbanList : [],
        recentPositions : [],

        homeAddress : {
          positionText: '',
          positionTextDetail: '',
          positionList: [],
          selectedPosition: null,
          showPositionList: false,
          marker: undefined,
          addressText: null,
        },

        suburban: {
          suburbanText: '',
          selectedSuburban: null,
          showSuburbanList: false,
        },

        startPoint: {
          positionText: '',
          positionList: [],
          selectedPosition: null,
          showPositionList: false,
          marker: undefined,
          addressText: null,
        },

        endPoint: {
          positionText: '',
          positionList: [],
          selectedPosition: null,
          showPositionList: false,
          marker: undefined,
          addressText: null,
        },

        waypoints: [
          {
            positionText: '',
            positionList: [],
            selectedPosition: null,
            showPositionList: false,
            addressText: null,
          }
        ],

        drivePathInfo: {
          routesInfo: {
            searchOption: '',
            trafficInfo: '',
            predictionType: 'departure',
            departure:'',
            destination:'',
            predictionTime:''
          }
        },
        drivingPath:null,
        path: [],
        loadMapFlag: false,

        locationInfo: {
          suburban: null,
          departure: null,
          departurePoint: null,
          destination: null,
          destinationPoint: null,
          waypoint1: null,
          waypoint1Point: null,
          waypoint2: null,
          waypoint2Point: null,
          waypoint3: null,
          waypoint3Point: null,
          driveTime: null, //ms
          driveDistance: null, // m
          _2UFare: null,
          _2UServiceFare: null,
          startPointX: null,
          startPointY: null,
          endPointX: null,
          endPointY: null,
          radioTownLocationInfo : '',
        },
        commentsInfo: {
          departureComment: null,
          destinationComment: null,
          waypoint1Comment: null,
          waypoint2Comment: null,
          waypoint3Comment: null,
        },
        disableWayPointAddBtn: false,
        disableWayPointRemoveBtn: true,
        wayPointStatus: false,
        comments:[],
      },
      default: {
        radioTownLocationInfo : "downTown",
        homeAddress : {
          positionText: '',
          positionList: [],
          selectedPosition: null,
          showPositionList: false,
          marker: undefined,
          addressText: null,
        },

        suburban: {
          suburbanText: '',
          selectedSuburban: null,
          showSuburbanList: false,
        },

        startPoint: {
          positionText: '',
          positionList: [],
          selectedPosition: null,
          showPositionList: false,
          marker: undefined,
          addressText: null,
        },

        endPoint: {
          positionText: '',
          positionList: [],
          selectedPosition: null,
          showPositionList: false,
          marker: undefined,
          addressText: null,
        },

        waypoints: [
          {
            positionText: '',
            positionList: [],
            selectedPosition: null,
            showPositionList: false,
            addressText: null,
          }
        ],

        drivePathInfo: {
          routesInfo: {
            searchOption: '',
            trafficInfo: '',
            predictionType: 'departure',
            departure:'',
            destination:'',
            predictionTime:''
          }
        },

        locationInfo: {
          suburban: null,
          departure: null,
          departurePoint: null,
          destination: null,
          destinationPoint: null,
          waypoint1: null,
          waypoint1Point: null,
          waypoint2: null,
          waypoint2Point: null,
          waypoint3: null,
          waypoint3Point: null,
          driveTime: null, //ms
          driveDistance: null, // m
          _2UFare: null,
          _2UServiceFare: null,
          startPointX: null,
          startPointY: null,
          endPointX: null,
          endPointY: null,
        },
        commentsInfo: {
          departureComment: null,
          destinationComment: null,
          waypoint1Comment: null,
          waypoint2Comment: null,
          waypoint3Comment: null,
        },
        comments:[],
      },

      townLocationInfo : [
        {label:'시내', value:'downTown'},
        {label:'시외', value:'suburbs'},
      ],

      sendJSON: {
        routesInfo: {
          searchOption: "00",
          trafficInfo: "Y",
          predictionType: "departure",
        }
      },

      mapInfo: {
        map:null,
        mapOptions: {
          lat:null,
          lng:null,
        },
        zoom:0,
        initLayers: [],
        naverMapBound: {north:null, south:null, west: null, east: null},
        initFitBound: true,
      },

      map: {
        width: 1100,
        height: 500,
        info: false,
        marker: null,
        count: 1,
        map: null,
        isCTT: false,

        mapOptions: {
          lat: 35.1348300,
          lng: 129.0830061,
          zoom: 13,
          zoomControl: true,
          zoomControlOptions: {position: 8},
          mapTypeControl: false ,
        },
        initLayers: ['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT'],
      },
      polyline: null,
      waypointMaxCnt: 3,
      recentLocationPoint : '',
      cId: '',
      address:'',
    }),
    watch: {
      fareInfo: {
        deep: true,
        handler(val) {
          this.selectedFareType = val.fareType;
          this.selectedFareDetail = val.fareDetail;

          if (!!this.selectedFareDetail) {
            const area = this.selectedFareDetail.split('구간')[0];
            this.input.suburban.selectedSuburban = this.sortedSuburbanAreaFareTypes[parseInt(area)-1];
          }

          if (!this.selectedFareType) {
            this.input.radioTownLocationInfo = 'downTown';
          } else if (this.selectedFareType.includes('suburban')) {
            this.input.radioTownLocationInfo = 'suburbs';
          } else {
            this.input.radioTownLocationInfo = 'downTown';
          }
        }
      },
      serviceTime() {
        this.reqMapDrivingPath();
      },
      'input.radioTownLocationInfo'() {
        this.reqMapDrivingPath();
      },
      'input.suburban.selectedSuburban'() {
        if(this.radioTownLocationInfo === "suburbs") {
          //시내구간이 아닌데 경유지에 data가 있으면 clearble 이벤트 주기
          if(this.input.waypoints[0].addressText != null || this.input.waypoints.length > 1) {
            this.resetWaypoint();
          }
          this.input.wayPointStatus = true;
          this.input.disableWayPointAddBtn = true;
        } else {
          this.input.wayPointStatus = false;
          this.input.disableWayPointAddBtn = false;
        }
        this.reqMapDrivingPath();
      },
      locationData: {
        deep: true,
        handler(newVal) {
          if(!!newVal && Object.keys(newVal).length > 0) {
            let position = '';

            if (!!newVal.departure) {
              this.input.startPoint.addressText = newVal.departure;
              position = newVal.departure.Point.split(',');
              this.input.startPoint.selectedPosition = {x: position[0], y: position[1]};
            }

            if (!!newVal.destination){
              this.input.endPoint.addressText = newVal.destination;
              position = newVal.destinationPoint.split(',');
              this.input.endPoint.selectedPosition = {x: position[0], y: position[1]};
            }

            if(!!newVal.waypoint1) {
              this.input.waypoints[0].addressText = newVal.waypoint1;
              position = newVal.waypoint1Point.split(',');
              this.input.waypoints[0].selectedPosition = {x: position[0], y: position[1]};
            }

            if(!!newVal.waypoint2) {
              position = newVal.waypoint2Point.split(',');
              if (this.input.waypoints.length === 1) {
                this.input.waypoints.push({
                  addressText: newVal.waypoint2,
                  selectedPosition: {x: position[0], y: position[1]}
                });
              } else {
                this.input.waypoints[1].addressText = newVal.waypoint2;
                this.input.waypoints[1].selectedPosition = {x: position[0], y: position[1]};
              }
            }

            if(!!newVal.waypoint3) {
              position = newVal.waypoint3Point.split(',');
              if (this.input.waypoints.length === 2) {
                this.input.waypoints.push({
                  addressText: newVal.waypoint3,
                  selectedPosition: {x: position[0], y: position[1]}
                });
              } else {
                this.input.waypoints[2].addressText = newVal.waypoint3;
                this.input.waypoints[2].selectedPosition = {x: position[0], y: position[1]};
              }
            }
          }
          if(!newVal.departure && !newVal.destination) this.reqMapDrivingPath();
        }
      },
      'input.locationInfo' : {
        deep: true,
        handler(newVal) {
          this.$emit('update:locationData', newVal);
        }
      },
      'input.startPoint.positionText'(newVal) {
        if (!newVal || newVal.length === 0) {
          this.input.startPoint.addressText = null;
          this.input.startPoint.selectedPosition = null;
          this.input.startPoint.marker.setMap(null);

          this.input.locationInfo.departure = null;
          this.input.locationInfo.departurePoint = null;
          this.input.locationInfo.startPointX = null;
          this.input.locationInfo.startPointY = null;
          this.input.comments[0] = '';
          this.input.commentsInfo.departureComment = null;

          this.input.locationInfo.driveDistance = null;
          this.input.locationInfo.driveTime = null;
          this.input.locationInfo._2UFare = null;
          this.input.locationInfo._2UServiceFare = null;
          this.reqMapDrivingPath();
        }
      },
      'input.endPoint.positionText'(newVal) {
        if (!newVal || newVal.length === 0) {
          this.input.endPoint.addressText = null;
          this.input.endPoint.selectedPosition = null;
          this.input.endPoint.marker.setMap(null);

          this.input.locationInfo.destination = null;
          this.input.locationInfo.destinationPoint = null;
          this.input.locationInfo.endPointX = null;
          this.input.locationInfo.endPointY = null;
          this.input.comments[1] = '';
          this.input.commentsInfo.destinationComment = null;

          this.input.locationInfo.driveDistance = null;
          this.input.locationInfo.driveTime = null;
          this.input.locationInfo._2UFare = null;
          this.input.locationInfo._2UServiceFare = null;
          this.reqMapDrivingPath();
        }
      },
      'input.waypoints': {
        deep: true,
        handler(newVal, oldVal) {
          //예약 변경일 경우 else문에 들어가게 되어 초기화되므로 예약 접수일 경우에만 적용되도록
          if (Object.keys(this.$route.params).length === 0) {
            // 경유지 (-) 버튼 클릭 시
            if (oldVal.length > newVal.length) {
              if (oldVal[oldVal.length - 1].selectedPosition) {
                this.reqMapDrivingPath();
              }
            }
            // 경유지 textField text 길이가 0이거나 null 일 경우
            else {
              newVal.forEach((item, idx) => {
                if (item.positionText === null) {
                  item.addressText = null;
                  item.selectedPosition = null;
                  item.positionText = null;
                  this.input.comments[idx + 2] = null;
                  if (idx === 0) this.input.commentsInfo.waypoint1Comment = null;
                  if (idx === 1) this.input.commentsInfo.waypoint2Comment = null;
                  if (idx === 2) this.input.commentsInfo.waypoint3Comment = null;
                  this.reqMapDrivingPath();
                }
              });
            }
          }
        },
      },
      'input.comments' : {
        deep: true,
        handler() {
          this.input.commentsInfo.departureComment = this.input.comments[0];
          this.input.commentsInfo.destinationComment = this.input.comments[1];
          this.input.commentsInfo.waypoint1Comment = this.input.comments[2];
          this.input.commentsInfo.waypoint2Comment = this.input.comments[3];
          this.input.commentsInfo.waypoint3Comment = this.input.comments[4];
        }
      },
      'input.commentsInfo' : {
        deep: true,
        handler(newVal) {
          this.$emit('update:commentsData', newVal);
        },
      },
      commentsData : {
        deep: true,
        handler(newVal) {
          this.input.comments = [newVal.departureComment, newVal.destinationComment, newVal.waypoint1Comment, newVal.waypoint2Comment, newVal.waypoint3Comment];
        },
      },
      customerData: {
        deep: true,
        handler(newVal) {
          if (!!newVal && newVal.length > 0) {
            if(this.customerData.id !== null ){
              this.cId = this.customerData.id;
            }
          } else {
            if(this.polyline.getPath()) {
              let path = this.polyline.getPath();
              path.clear();
            }
            this.initData();
            this.input.suburban.selectedSuburban = this.sortedSuburbanAreaFareTypes[0];
          }
        }
      },
      address(newVal){
        let text = newVal.address.substring(0, newVal.address.indexOf('|'));
        let pointX = newVal.address.substring(newVal.address.indexOf('|')+1, newVal.address.indexOf(','));
        let pointY = newVal.address.substring(newVal.address.indexOf(',')+1);

        if(this.recentLocationPoint === 'departure') {
        this.input.startPoint.addressText = text;
        this.input.startPoint.selectedPosition = {x: pointX, y: pointY};
        } else if (this.recentLocationPoint === 'destination') {
        this.input.endPoint.addressText = text;
        this.input.endPoint.selectedPosition = {x: pointX, y: pointY};
        } else if (this.recentLocationPoint === 'waypoint1') {
          this.input.waypoints[0].addressText = text;
          this.input.waypoints[0].selectedPosition = {x: pointX, y: pointY};
        } else if (this.recentLocationPoint === 'waypoint2') {
          this.input.waypoints[1].addressText = text;
          this.input.waypoints[1].selectedPosition = {x: pointX, y: pointY};
        } else if (this.recentLocationPoint === 'waypoint3') {
          this.input.waypoints[2].addressText = text;
          this.input.waypoints[3].selectedPosition = {x: pointX, y: pointY};
        }
        this.reqMapDrivingPath();
      }
    },
    computed: {
      serviceTime() {
        if (!this.reservationData) {
          return 0;
        }
        return this.reservationData.selectedServiceTime < 0 ? this.reservationData.selectedServiceInput : this.reservationData.selectedServiceTime;
      },
      sortedSuburbanAreaFareTypes() {
        return this.suburbanAreaFareTypes.sort((f1, f2) => f1.area - f2.area);
      },
      getDriveTime() {
        const driveTime = this.$func.msToTimeFormat(this.input.locationInfo.driveTime);
        return driveTime || 0;
      },
      getDriveDistance() {
        return Number(this.input.locationInfo.driveDistance/1000).toFixed(3)
      },

      async getHomeAddress () {
        if (this.customerData !== null && this.customerData.length > 0) {
          this.input.homeAddress.positionList = [];
          let address = '', addressDetails = '', addressLat = 0, addressLng = 0;
          if(typeof this.customerData[0].address === 'undefined') {
            let res;
            res = await this.$api.getCustomer(this.customerData[0].id)

            address = res.data.address;
            addressDetails = res.data.addressDetails;
            addressLat = res.data.addressLat;
            addressLng = res.data.addressLng;
          } else {
            address = this.customerData[0].address;
            addressDetails = this.customerData[0].addressDetails;
            addressLat = this.customerData[0].addressLat;
            addressLng = this.customerData[0].addressLng;
          }
          if(addressLat === 0 || addressLng === 0) {
            this.input.homeAddress.positionText = address;
            this.input.homeAddress.positionTextDetail = addressDetails;
            if (!!this.input.homeAddress.positionText) {
              await this.onSetPosition(this.input.homeAddress, true);
            }
          } else {

            let position = {};
            const addrArr = address.split('(');
            position['address_name'] = addrArr[0];
            position['place_name'] = addrArr[addrArr.length-1].replace(')', '');
            position['comment'] = addressDetails;
            position['x']=addressLng;
            position['y']=addressLat;

            this.input.homeAddress.positionList.push(position);
          }
        }
      },
      async getRecentAddressList() {
        //최근목록 불러오기
        if (this.customerData !== null && this.customerData.length > 0){
          this.input.recentPositions=[];

          const recentList = await this.$api.getRecentLocationList('departure', this.customerData[0].id);
          for (let item of recentList.data) {
            let slashIdx = item.indexOf('/');
            let comment = item.substring(0, slashIdx);
            let text = item.substring(slashIdx + 1, item.indexOf('|'));
            let point = item.substring(item.indexOf('|')+1).split(',');

            let position = {};

            const textArr = text.split('(');

            position['place_name'] = textArr[0];
            position['address_name'] = textArr[textArr.length - 1].replace(')', '');
            position['comment'] = comment;
            position['x'] = point[0];
            position['y'] = point[1];

            //중복되는 내역들을 제거
            let previous = false;
            for(let i=0;i<this.input.recentPositions.length;i++) {
              if(this.input.recentPositions[i].place_name === position['place_name'] && this.input.recentPositions[i].address_name === position['address_name']) {
                if(this.input.recentPositions[i].comment === '' && position['comment'] !== '') this.input.recentPositions.splice(i, 1)
                else if(this.input.recentPositions[i].comment !== '' && position['comment'] === '') previous = true;
              }
            }
            if(!previous) this.input.recentPositions.push(position);
            previous = false;
            // this.input.recentPositions.push(position)

          }
        }
      },
    },
    methods: {
      getAreaText(info) {
        return (!!info) ? `${info.area}구간 - ${info.areaDescription}(${info.fare}원)` : '';
      },
      showRecentList (point, event) {
        try {
          if (event.keyCode !== 13) {
            if (point.positionText.length === 0) {
              point.showPositionList = true;
            } else {
              point.showPositionList = false;
              point.positionList = [];
            }
          }
        } catch (e) {
          if (!!event === false || !!point.positionText === false) {
            point.showPositionList = true;
          }
        }
      },
      hiddenHomeAndRecentList(point) {
        if (!!point.positionList === true && !!point.positionText === true) {
          if (point.positionList.length > 0 && point.positionText.length > 0) {
            return true;
          }
        }

        return false;
      },
      startPointClear(startPoint, event) {
        if (startPoint.selectedPosition) {
          this.input.startPoint.addressText = null;
          this.input.startPoint.positionText = null;
          this.input.startPoint.comment = null;
          this.input.comments[0] = null;
          this.input.commentsInfo.departureComment = null;
          this.input.startPoint.selectedPosition = null;

          this.showRecentList(startPoint, event);
          this.$refs['startPoint'].focus();
          this.reqMapDrivingPath();
        }
      },
      endPointClear(endPoint, event) {
        if (endPoint.selectedPosition) {
          this.input.endPoint.addressText = null;
          this.input.endPoint.positionText = null;
          this.input.endPoint.comment = null;
          this.input.comments[1] = null;
          this.input.commentsInfo.destinationComment = null;
          this.input.endPoint.selectedPosition = null;

          this.showRecentList(endPoint, event);
          this.$refs['endPoint'].focus();
          this.reqMapDrivingPath();
        }
      },
      waypointClear(waypoint, event, idx) {
        if (waypoint.selectedPosition) {
          if (idx === 0) this.input.commentsInfo.waypoint1Comment = null;
          if (idx === 1) this.input.commentsInfo.waypoint2Comment = null;
          if (idx === 2) this.input.commentsInfo.waypoint3Comment = null;
          this.input.comments[idx + 2] = null;
          this.input.waypoints[idx].addressText = null;
          this.input.waypoints[idx].positionText = null;
          this.input.waypoints[idx].selectedPosition = null;

          this.showRecentList(waypoint, event);
          this.$refs['wayPoint'][idx].focus();
          this.reqMapDrivingPath();
        }
      },
      resetWaypoint() {
        this.input.waypoints = [];
        this.input.comments = [];
        this.reqMapDrivingPath();
      },
      showSuburbanText(text) {
        if (!!text === false) {
          return;
        }
        let textArray = '';
        if (Object.keys(text).length > 0) {
          textArray = text.configName.split('|');
        }
        return textArray ? textArray[0] + ' - ' + textArray[1] + '(' + textArray[2] + ')' : '';
      },

      checkOverlapLocation(front, back, select) {
          if(
            !(front.x.toString() === select.x.toString() && front.y.toString() === select.y.toString()) &&
            !(back.x.toString() === select.x.toString() && back.y.toString() === select.y.toString())
          ) {
            return true
          }else {
            return false
          }
      },
      async reqMapDrivingPath() {
        try {
          const startPointSelectPositionObj = this.input.startPoint.selectedPosition;
          const endPointSelectPositionObj = this.input.endPoint.selectedPosition;
          if (!!startPointSelectPositionObj === false || !!endPointSelectPositionObj === false) {
            return;
          } else if (Object.keys(startPointSelectPositionObj).length === 0 || Object.keys(endPointSelectPositionObj).length === 0) {
            return;
          }

          let departure = {
            name: "departure",
            lon: startPointSelectPositionObj.x.toString(),
            lat: startPointSelectPositionObj.y.toString()
          }
          let destination = {
            name: "destination",
            lon: endPointSelectPositionObj.x.toString(),
            lat: endPointSelectPositionObj.y.toString()
          }

          let waypointMaxIndex = 0;

          this.input.waypoints.forEach( (point, index) => {
            if(point.selectedPosition) {
              waypointMaxIndex ++;
              this.input.waypoints[index].index = waypointMaxIndex
            }
          })

          let firstPoint = this.input.waypoints.find(findPoint => {return findPoint.index === 1})
          let secondPoint = this.input.waypoints.find(findPoint => {return findPoint.index === 2})
          let finalPoint = this.input.waypoints.find(findPoint => {return findPoint.index === 3})

          let wayPointArray = [];
          this.input.waypoints.forEach(point => {

            let push = false;

            if(point.selectedPosition) {
              if(point.index === 1) {
                if(point.index === waypointMaxIndex) {
                  push = this.checkOverlapLocation(startPointSelectPositionObj, endPointSelectPositionObj, point.selectedPosition)
                }else {
                  push = this.checkOverlapLocation(startPointSelectPositionObj, secondPoint.selectedPosition, point.selectedPosition)
                }
              }else if(point.index === 2) {
                if(point.index === waypointMaxIndex) {
                  push = this.checkOverlapLocation(firstPoint.selectedPosition, endPointSelectPositionObj, point.selectedPosition)
                }else {
                  push = this.checkOverlapLocation(firstPoint.selectedPosition, finalPoint.selectedPosition, point.selectedPosition)
                }
              }else if(point.index === 3) {
                push = this.checkOverlapLocation(firstPoint.selectedPosition, endPointSelectPositionObj, point.selectedPosition)
              }
            }

            if(push) {
              wayPointArray.push({"lon": point.selectedPosition.x.toString(), "lat": point.selectedPosition.y.toString()});
            }

          })

          if (wayPointArray.length > 0) {
            this.sendJSON.routesInfo["wayPoints"] = {};
            this.sendJSON.routesInfo.wayPoints["wayPoint"] = wayPointArray;
          } else {
            delete this.sendJSON.routesInfo["wayPoints"];
          }

          this.sendJSON.routesInfo["departure"] = departure;
          this.sendJSON.routesInfo["destination"] = destination;
          this.sendJSON.routesInfo["predictionTime"] = `${this.reservationData.selectedDate}T${this.reservationData.selectedTime}:00+0900`;
          // predictionTime format: "2020-10-18T17:00:22+0900"

          // 기타 시간 입력 선택 시 숫자가 아닌 잘못된 값이나 최초에 비어있는 경우('') api 날리지 않게 하기 위함
          if (isNaN(parseInt(this.serviceTime))) {
            return;
          }

          /**
           * 시내 / 시외 구분 기준: 선택한 radio button 의 값
           * 실제 보내는 fareType : 로그인 시 해당 센터에서 설정 한 Store 에 있는 시내요금 or 시외요금의 config 값
           * suburbanArea : 시외 구간별 요금으로 설정 된 경우 보내는 optional 한 값
           */
          let fareType;
          fareType = this.input.radioTownLocationInfo === 'downTown' ? this.fareType : this.suburbanFareType;

          const suburbanArea = fareType === 'suburban_fr_area' ? this.input.suburban.selectedSuburban.area : '';

          const param = `${JSON.stringify(this.sendJSON)}?serviceTime=${this.serviceTime}&fareType=${fareType}&suburbanArea=${suburbanArea}`;
          const res = await this.$api.getMapDrivingPath(param);

          const summary = res.data.features[0].properties;
          const path = res.data.features;

          let path1 = path.filter(item => item.geometry.coordinates.length !== 2);
          path1 = path1.map(item => item.geometry.coordinates);
          path1 = path1.map(item => item.map(item => ({lat: item[1], lng: item[0]})));
          let pathList = [];
          path1.map(item => item.map(item => pathList.push(item)));
          this.input.path = pathList;

          if(waypointMaxIndex === 0 && departure.lon === destination.lon && departure.lat === destination.lat ) {
            //경유지 없이 출발지 / 도착지 같을 경우 임의 데이터 처리
            this.input.path.push({lat: departure.lat, lng: departure.lon})
            summary.totalTime = 1
          }

          if (this.polyline) {
            this.polyline.setPath(this.input.path);
          }
          if (this.map) {
            try {
              let pathCenter = this.input.path[parseInt(this.input.path.length / 2)];
              this.map.setCenter({y: pathCenter.lat, _lat: pathCenter.lat, x: pathCenter.lng, _lng: pathCenter.lng});
              this.map.setZoom(13, true);
            } catch (e) {
              console.log(e)
            }
          }

          // setting info
          this.input.locationInfo.departure = this.input.startPoint.addressText;
          this.input.locationInfo.departurePoint = this.input.startPoint.selectedPosition.x + ',' + this.input.startPoint.selectedPosition.y;
          this.input.locationInfo.destination = this.input.endPoint.addressText;
          this.input.locationInfo.destinationPoint = this.input.endPoint.selectedPosition.x + ',' + this.input.endPoint.selectedPosition.y;
          this.input.locationInfo.waypoint1 = this.input.waypoints[0] && this.input.waypoints[0].addressText ? this.input.waypoints[0].addressText : null;
          this.input.locationInfo.waypoint1Point = this.input.waypoints[0] && this.input.waypoints[0].selectedPosition ? this.input.waypoints[0].selectedPosition.x + ',' + this.input.waypoints[0].selectedPosition.y : null;
          this.input.locationInfo.waypoint2 = this.input.waypoints[1] && this.input.waypoints[1].addressText ? this.input.waypoints[1].addressText : null;
          this.input.locationInfo.waypoint2Point = this.input.waypoints[1] && this.input.waypoints[1].selectedPosition ? this.input.waypoints[1].selectedPosition.x + ',' + this.input.waypoints[1].selectedPosition.y : null;
          this.input.locationInfo.waypoint3 = this.input.waypoints[2] && this.input.waypoints[2].addressText ? this.input.waypoints[2].addressText : null;
          this.input.locationInfo.waypoint3Point = this.input.waypoints[2] && this.input.waypoints[2].selectedPosition ? this.input.waypoints[2].selectedPosition.x + ',' + this.input.waypoints[1].selectedPosition.y : null;
          this.input.locationInfo.driveTime = summary['totalTime'];
          this.input.locationInfo.driveDistance = summary['totalDistance'];
          this.input.locationInfo._2UFare = summary['2UFare'];
          this.input.locationInfo._2UServiceFare = summary['2UServiceFare'];
          this.input.locationInfo.suburban = this.input.suburban.selectedSuburban;

          this.input.locationInfo.fareType = this.input.radioTownLocationInfo === 'downTown' ? this.fareType : this.suburbanFareType; // 실제 선택한 fareType
          this.input.locationInfo.fareDetail = '';
          if (this.input.radioTownLocationInfo !== 'downTown' && fareType === 'suburban_fr_area') {
            // 시외이면서 구간요금제로 설정 된 경우 당시의 요금제 타입을 detail 에 저장한다.
            // 요금제가 변경되어도 예약당시의 요금제 기준으로 예약정보를 보기위함
            this.input.locationInfo.fareDetail = `${this.input.suburban.selectedSuburban.area}구간 - ${this.input.suburban.selectedSuburban.areaDescription}`;
          }

          this.input.locationInfo.radioTownLocationInfo = this.input.radioTownLocationInfo;
          this.input.locationInfo.startPointX = this.input.startPoint.selectedPosition.x;
          this.input.locationInfo.startPointY = this.input.startPoint.selectedPosition.y;
          this.input.locationInfo.endPointX = this.input.endPoint.selectedPosition.x;
          this.input.locationInfo.endPointY = this.input.endPoint.selectedPosition.y;

          this.input.commentsInfo.departureComment = this.input.comments[0];
          this.input.commentsInfo.destinationComment = this.input.comments[1];
          this.input.commentsInfo.waypoint1Comment = this.input.comments[2];
          this.input.commentsInfo.waypoint2Comment = this.input.comments[3];
          this.input.commentsInfo.waypoint3Comment = this.input.comments[4];

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'SearchLocation/ reqDrivingPath', msg: '경로에 대한 결과가 없습니다.'});
        }
      },

      onMapLoad(vue) {
        this.map = vue;
        this.input.loadMapFlag = true;
      },
      onMapMarkerClicked(event) {
        this.info = !this.info;
      },
      onMapMarkerLoaded(vue) {
        vue.marker.setDraggable(false);
        vue.marker.setCursor('');
        vue.marker.setClickable(true);
      },
      onMapPolylineLoaded(vue) {
        if (vue) {
          vue.polyline.setOptions({strokeWeight: 3, strokeColor: 'blue'});
          this.polyline = vue;
        }
      },
      async onSetPosition(bind, isHomeAddress) {
        // 주소-좌표 변환 객체 생성
        const geocoder = new kakao.maps.services.Geocoder();
        // 주소로 좌표 검색
        await geocoder.addressSearch(bind.positionText, (geoResult, geoStatus) => {
          const result = [];
          // 결과값 존재 시 [0] 번째 값만 추가
          if (geoStatus === kakao.maps.services.Status.OK) {
            result.push({
              address_name: geoResult[0].address_name,
              place_name: bind.positionText,
              comment: bind.positionTextDetail,
              x: geoResult[0].x,
              y: geoResult[0].y
            });
          }

          let lat = null;
          let lng = null;
          const userInfo = this.$store.state.userInfo.garagePoint; //"126.925468,37.523706"
          if (userInfo.length > 0) {
            lat = userInfo.split(',')[1];
            lng = userInfo.split(',')[0];
          }

          if (!isHomeAddress) {
            //장소 검색 객체 생성
            const ps = new kakao.maps.services.Places();
            //키워드로 장소 검색
            // CenterPoint 기준으로 리스트 출력
            ps.keywordSearch(bind.positionText, (data, searchStatus, pagination) => {
                  // 주소좌표, 키워드 장소 둘다 결과 값이 없을 경우
                  if (geoStatus !== kakao.maps.services.Status.OK && searchStatus !== kakao.maps.services.Status.OK) {
                    this.$store.commit('snackbar', {timeout: 2000, msg: '결과가 존재하지 않습니다.'});
                  }
                  // 결과값이 하나라도 존재 할 경우 menu list 출력
                  else {
                    bind.positionList = [...result, ...data];
                    bind.showPositionList = true;
                  }
                },
                {
                  x: lng, //longitude
                  y: lat //latitude
                });
          } else {
            bind.positionList = [...result];
            bind.showPositionList = true;
          }
        });
      },
      onSelectedPosition(position, bind) {
        const {x, y, address_name, place_name, comment} = position;
        bind.selectedPosition = position;
        bind.positionText = place_name;
        bind.addressText = place_name + '(' + address_name + ')';
        bind.comment = comment;

        if (bind === this.input.startPoint) this.input.comments[0] = bind.comment;
        else if (bind === this.input.endPoint) this.input.comments[1] = bind.comment;
        else if (bind === this.input.waypoints[0]) this.input.comments[2] = bind.comment;
        else if (bind === this.input.waypoints[1]) this.input.comments[3] = bind.comment;
        else if (bind === this.input.waypoints[2]) this.input.comments[4] = bind.comment;

        if (this.map) {
          this.map.mapOptions.lat = y;
          this.map.mapOptions.lng = x;
          this.map.setCenter({y, _lat: y, x, _lng: x});
          this.map.setZoom(13, false);
        }
        if (bind.marker && Object.keys(bind.marker).length > 0) {
          bind.marker.setMap(null);
        }
        bind.marker = this.createMarker(y, x);
        //drivingPath 요청
        if (this.input.startPoint.selectedPosition && this.input.endPoint.selectedPosition) {
          this.reqMapDrivingPath();
        }
      },
      createMarker(lat, lng) {
        return new naver.maps.Marker({
          position: new naver.maps.LatLng(lat, lng),
          map: this.mapInfo.map,
        });
      },
      onCalcWayPoints(operator) {
        if (operator === '+') {
          this.input.waypoints.push({
            positionText: '',
            positionList: [],
            selectedPosition: null,
            showPositionList: false,
            addressText: null,
          });

          if (this.input.disableWayPointRemoveBtn) {
            this.input.disableWayPointRemoveBtn = false;
          } else if (this.input.waypoints.length === this.waypointMaxCnt) {
            this.input.disableWayPointAddBtn = true;
          }

        } else if (operator === '-') {

          // remove the last waypoint
          const removedWayPoint = this.input.waypoints.splice(this.input.waypoints.length - 1);
          if (this.input.disableWayPointAddBtn) {
            this.input.disableWayPointAddBtn = false;
          } else if (this.input.waypoints.length === 1) {
            this.input.disableWayPointRemoveBtn = true;
          }

          // search drivingPath without waypoint
          if (removedWayPoint.selectedPosition) {
            this.reqMapDrivingPath();
          }
        }
      },
      isEnableSuburban() {
        return this.input.radioTownLocationInfo !== 'suburbs';
      },
      setMapViewInit() {
        const centerPoint = this.$store.state.centerInfo.centerPoint;
        if (centerPoint !== null && centerPoint !== undefined) {
          let pointArray = centerPoint.split(',');
          if (this.map) {
            this.map.mapOptions.lng = pointArray[0];
            this.map.mapOptions.lat = pointArray[1];
          }
        }
      },
      initData() {
        this.input = JSON.parse(JSON.stringify(this.$func.initObjectData(this.input, this.default)));
      },
      async getDefault() {
        const centerId = this.$store.state.centerInfo.centerId;

        const { data:fareData } = await this.$api.getCenterInfoById(centerId);

        this.fareType = fareData.fareType.configValue;
        this.suburbanFareType = fareData.suburbanFareType.configValue;
        if (this.suburbanFareType.includes('area')) {
          const { data:suburbanAreaFares } = await this.$api.getSuburbanAreaFares(centerId, this.suburbanFareType);
          this.suburbanAreaFareTypes = suburbanAreaFares;
          this.input.suburban.selectedSuburban = this.sortedSuburbanAreaFareTypes[0];

          if (!this.selectedFareDetail) {
            return;
          }
          // 이미 예약이 존재하는 경우 설정해줌
          const area = this.selectedFareDetail.split('구간')[0];
          this.input.suburban.selectedSuburban = this.sortedSuburbanAreaFareTypes[parseInt(area)-1];
        }
        await this.reqMapDrivingPath();
      }
    },
    async created() {
      await this.setMapViewInit();
      await this.getDefault();
    },
  }
</script>

<style scoped>
  .info-window-container {
    padding: 10px;
    width: 300px;
    height: 100px;
  }
  .info-container {
    width: 250px;
    height: 110px;
    position: absolute;
    background-color: rgba(0,0,0,0.5);
    z-index: 5;
    padding: 10px;
  }
  .v-menu__content {
    z-index: 101 !important;
  }
</style>